import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const projectMaterials = {
  'app.projectMaterials':     (pId=':projectId') =>  `${prefix}/projects/${pId}/materials`
}
